/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileIfc = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4zm11 3.414V7h1.586z" />
        <path d="M12.386 17v-4.87h1.046V17zm1.996 0v-4.87h3.109v.884h-2.064v1.226h1.83v.884h-1.83V17zm7.412-1.065v.87a3.114 3.114 0 0 1-.61.202c-.228.058-.48.087-.757.087-.781 0-1.373-.221-1.775-.664-.402-.446-.603-1.087-.603-1.922 0-.514.098-.954.294-1.32.197-.371.476-.655.838-.851.362-.201.793-.302 1.293-.302.237 0 .456.025.657.074s.377.112.529.188v.884a4.157 4.157 0 0 0-.616-.188 2.406 2.406 0 0 0-.496-.053c-.46 0-.813.136-1.059.408-.245.273-.368.66-.368 1.16 0 .54.12.958.361 1.252.242.29.597.436 1.066.436.187 0 .377-.02.57-.06.196-.045.421-.112.676-.201z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileIfc as FileIfc };
